import dashboardPrestashopUpdate from './component'
import { commonRenderProps } from '../../common/props'

export default (context: object, container: string) => {
  const props = {
    ...commonRenderProps({ context }),
  }

  dashboardPrestashopUpdate(props).render(container)
}
